import { useState, useEffect } from "react"
import { CSvgArrowRight, CSvgCalender, CSvgReport, CSvgClock, CSvgHelp, CSvgTime } from '../../components/CSvg'
import { Link, useNavigate } from "react-router-dom";
import { ContextNav } from "../../context";
import { NavBar, DrowerBottom, ModalFilterDate, SkeletonRollCall, Pagination } from "../../components";
import { ConverDurationToMin, ConvertMiladiDateToJalili, GetToDay, StartCurrentMonth } from "../../utils";
import { handelGetListDelayMethod } from "../../methods/delay-methods";


export const Delay = () => {
    const [activeItem, setActiveItem] = useState<number>(-1)
    const [visibleFilter, setVisibleFilter] = useState<boolean>(false)
    const [displaySkeleton, setDisplaySkeleton] = useState<boolean>(false)
    const [displayBtn, setDisplayBtn] = useState<boolean>(false)
    const [delayList, setDelayList] = useState<any>(null)
    const [visibleDate, setVisibleDate] = useState<boolean>(false)
    const [dateFilter, setDateFilter] = useState<any>(null)
    const [filterStatus, setFilterStatus] = useState<number>(-1)
    const [pagination, setPagination] = useState({
        'current': 1,
        'total': 1,
    })

    const handelFilterStatus = (id: number) => {
        setFilterStatus(id)
        handelGetListDelayMethod(dateFilter?.start_jalali, dateFilter?.end_jalali, setDelayList, setDisplaySkeleton, id, pagination, setPagination)
        setVisibleFilter(false)
    }

    const handelFilterDate = () => {
        handelGetListDelayMethod(dateFilter?.start_jalali, dateFilter?.end_jalali, setDelayList, setDisplaySkeleton, filterStatus, pagination, setPagination)
    }

    useEffect(() => {
        document.title = "تاخیر | دایان"
        if (pagination?.current) {
            handelGetListDelayMethod(dateFilter?.start_jalali, dateFilter?.end_jalali, setDelayList, setDisplaySkeleton, filterStatus, pagination, setPagination)
        }
    }, [pagination?.current])

    return (
        <>
            <div className='w-full min-h-screen flex flex-col'>
                <NavBar
                    title='تاخیر'
                    isCalender={true}
                    isFilter={true}
                    onClickFilter={() => { setVisibleFilter(true) }}
                    onClickCalender={() => { setVisibleDate(true) }}
                />
                <div className='w-full flex flex-col p-[20px]'>
                    <div className='w-full flex flex-col overflow-hidden '>
                        {displaySkeleton == false && delayList?.logs?.data?.map((item: any, index: number) =>
                            <div key={index} onClick={() => { setActiveItem(index) }} className='w-full cursor-pointer  flex justify-end bg-[#f9f9f9] shadow rounded-md mt-3 text-sm overflow-hidden relative'>
                                <div className={`w-[35px] absolute top-0 bottom-0 right-0  flex items-center justify-center  ${item.status == 2 && 'bg-[tomato]'} ${item.status == 0 && 'bg-orange-400'} ${item.status == 1 && 'bg-green-400'} `}>
                                    <div className=' text-sm text-white rotate-90 text-center '>
                                        <div className='w-[100px]'>
                                            {item.status == 0 && 'در حال بررسی '}
                                            {item.status == 1 && 'موجه '}
                                            {item.status == 2 && 'غیرموجه'}
                                        </div>
                                    </div>
                                </div>
                                <div className='w-[calc(100%-35px)]  px-[10px] flex flex-col'>
                                    <div className='w-full h-[40px]  border-b border-dashed border-gray-400 flex items-center justify-between'>
                                        <span className=''>شناسه تاخیر : {item.roll_call_id}</span>
                                        <CSvgArrowRight className={`w-[15px] transition-all fill-gray-800 ${activeItem == index ? 'rotate-90' : 'rotate-180'}`} />
                                    </div>
                                    <div className={`w-full pb-[15px] text-[13px] transition-all`}>
                                        <div className='w-full flex items-center mt-[15px]'>
                                            <CSvgCalender className="fill-gray-500 w-[20px]  " />
                                            <span className='text-gray-500 mx-1 '>تاریخ  :</span>
                                            <span>{ConvertMiladiDateToJalili(item?.created_at.slice(0, 10))}</span>
                                        </div>
                                        <div className={`w-full flex flex-col transition-all overflow-hidden ${activeItem == index ? 'max-h-[auto]' : 'max-h-0 '}`}>
                                            {/* <div className='w-full flex items-center mt-[15px]'>
                                                <CSvgClock className="fill-gray-500 w-[20px]  " />
                                                <span className='text-gray-500 mx-1 '>روز :</span>
                                                <span className=''>شنبه </span>
                                            </div> */}
                                            <div className='w-full flex items-center mt-[15px]'>
                                                <CSvgTime className="fill-gray-500 w-[20px]  " />
                                                <span className='text-gray-500 mx-1 '>مدت :</span>
                                                <span className=''>{item?.duration && item?.duration > 0 && ConverDurationToMin(item?.duration)}</span>
                                            </div>
                                            <div className='w-full flex items-center mt-[15px]'>
                                                <CSvgHelp className="fill-gray-500 w-[20px] " />
                                                <span className='text-gray-500 mx-1 '>علت :</span>
                                                <span>{item?.reason_id}</span>
                                            </div>
                                            <div className='w-full flex items-center mt-[15px]'>
                                                <CSvgReport className="fill-gray-500 w-[20px]  " />
                                                <span className='text-gray-500 mx-1 '> توضیح :</span>
                                                <span className=''>{item?.description}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {displaySkeleton == false && delayList?.logs?.data?.length == 0 &&
                            <div className="w-full h-[200px] flex justify-center items-center text-gray-400">
                                <span>موردی یافت نشد !</span>
                            </div>
                        }
                        {displaySkeleton && <SkeletonRollCall />}
                    </div>
                    <Pagination pagination={pagination} setPagination={setPagination} loading={displaySkeleton} />
                    {delayList?.logs?.data?.length != 0 &&
                        <div className='w-full h-[45px] bg-dayan-orange-50 flex items-center justify-between rounded-md my-[15px] px-[20px] text-white text-sm'>
                            <span>مجموع تاخیر</span>
                            <span>{delayList?.total_duration > 0 && ConverDurationToMin(delayList?.total_duration)}</span>
                        </div>
                    }
                </div>
            </div>

            <DrowerBottom visible={visibleFilter} setVisible={setVisibleFilter} >
                <div className='w-full flex flex-col justify-center items-center pt-[20px]'>
                    <button onClick={() => handelFilterStatus(-1)} className={`w-full h-[40px] rounded border border-dayan-orange-50  my-2 ${filterStatus == -1 ? 'text-dayan-orange-50' : 'text-[#252525]'}`}>همه</button>
                    <button onClick={() => handelFilterStatus(0)} className={`w-full h-[40px] rounded border border-dayan-orange-50  my-2 ${filterStatus == 0 ? 'text-dayan-orange-50' : 'text-[#252525]'}`}>در دست بررسی</button>
                    <button onClick={() => handelFilterStatus(1)} className={`w-full h-[40px] rounded border border-dayan-orange-50  my-2 ${filterStatus == 1 ? 'text-dayan-orange-50' : 'text-[#252525]'}`}>تایید شده</button>
                    <button onClick={() => handelFilterStatus(2)} className={`w-full h-[40px] rounded border border-dayan-orange-50  my-2 ${filterStatus == 2 ? 'text-dayan-orange-50' : 'text-[#252525]'}`}>رد شده</button>
                </div>
            </DrowerBottom>

            <ModalFilterDate
                visible={visibleDate}
                setVisible={setVisibleDate}
                dateKeeper={dateFilter}
                setDateKeeper={setDateFilter}
                btnLoader={displayBtn}
                onFinish={handelFilterDate}
            />

        </>
    );
}